import { render, staticRenderFns } from "./IntervalField.vue?vue&type=template&id=4739e94a&scoped=true&"
import script from "./IntervalField.vue?vue&type=script&lang=ts&"
export * from "./IntervalField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4739e94a",
  null
  
)

export default component.exports